module.exports = __webpack_public_path__ + "static/advanced-collapsible-navigation-031a1f20faaec275d38767f655c2d587.png";